import {Tooltip} from 'platform/components';
import {Box, HStack, Icon, Show, Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {isNotNilOrEmpty, Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {getAuctionTypePresentation} from '../../utils/getAuctionTypePresentation';

interface AuctionTypeBadgeProps extends TestIdProps {
  auctionType: string | Nullish;
  isCompact?: boolean;
  showDescription?: boolean;
  buyNowPrice?: string | Nullish;
}

export function AuctionTypeBadge(props: AuctionTypeBadgeProps) {
  const presentation = getAuctionTypePresentation(props.auctionType);
  if (isNil(presentation)) {
    return null;
  }

  return (
    <VStack spacing={2} align="flex-start">
      <Tooltip label={i18n.t('page.filters.labels.auctionType')}>
        <Box
          backgroundColor="palettes.neutral.20.100"
          borderRadius="small"
          paddingHorizontal={2}
          paddingVertical={1}
          data-testid={props['data-testid']}
        >
          <HStack spacing={1} align="center">
            <Icon value={presentation.icon} size={4} />
            <Text
              size={props.isCompact ? 'xxSmall' : 'small'}
              alternative
              data-testid={
                isNil(presentation.labelTestIdSuffix)
                  ? undefined
                  : suffixTestId(presentation.labelTestIdSuffix, props)
              }
            >
              {props.isCompact ? presentation.compactLabel : presentation.label}
            </Text>
            <Show when={isNotNilOrEmpty(props.buyNowPrice) ? props.buyNowPrice : null}>
              {(price) => (
                <Text size="xxSmall" noWrap data-testid={suffixTestId('buyNowFlag', props)}>
                  {price}
                </Text>
              )}
            </Show>
          </HStack>
        </Box>
      </Tooltip>
      <Show when={props.showDescription}>
        <Text size="xSmall" color="secondary" data-testid={suffixTestId('description', props)}>
          {presentation.description}
        </Text>
      </Show>
    </VStack>
  );
}
